<script>
    import { preventDefault } from 'svelte/legacy';

import {
    modalState, hideModal, showModal
} from "@app/store/modalStore.svelte.js";
import {
    projectState
} from "@app/store/projectStore.svelte.js";
import {
    eventGroupState
} from "@app/store/eventGroupStore.svelte.js";
import {
    historyState, insertHistoryAction, resetHistory
} from "@app/store/historyStore.svelte.js";
import {
    fade
} from "svelte/transition";
import {
    v4 as uuidv4
} from 'uuid';
import * as m from '@app/paraglide/messages.js';

let selectedMetadata = $state(), metadataProp = $state(""),
    metadataValue = $state("");

function reset(){
    selectedMetadata = undefined;
    metadataProp = "";
    metadataValue = "";
}

function selectMetadata(m){
    selectedMetadata = m;
    metadataProp = m.prop;
    metadataValue = m.value;
}

function addMetadata() {
    if (!metadataProp || !metadataValue){
        return;
    }

    eventGroupState[projectState.selected].metadata = [
        ...eventGroupState[projectState.selected].metadata,
        {
            id: uuidv4(),
            prop : metadataProp,
            value: metadataValue
        }
    ]

    insertHistoryAction({
        name: "insert metadata", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    reset();
}

function editMetadata() {
    let index = eventGroupState[projectState.selected].metadata.findIndex(m =>{
        return m.id === selectedMetadata.id;
    });

    if (index > -1 && metadataProp && metadataValue){
        eventGroupState[projectState.selected].metadata[index].prop = metadataProp;
        eventGroupState[projectState.selected].metadata[index].value = metadataValue;
    }

    

    insertHistoryAction({
        name: "update metadata", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    reset();
}

function removeMetadata(id) {
    eventGroupState[projectState.selected].metadata = eventGroupState[projectState.selected].metadata.filter(m =>{
        return m.id !== id
    });

    

    insertHistoryAction({
        name: "remove metadata", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    reset();
}
</script>

<div transition:fade={{ duration: 100 }} 
    class="modal {modalState.selected === 'eventGroupMetadata' ? 'show d-block' : ''}" 
    role="dialog"
    aria-labelledby="metadataTitle"
    aria-modal="true"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="metadataTitle">{m.event_group_metadata_title()}</h5>
                <button type="button" 
                    class="btn-close" 
                    aria-label={m.event_group_metadata_close_label()}
                    onclick={hideModal}>
                </button>
            </div>
            <div class="modal-body">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <form onsubmit={preventDefault(()=>{!selectedMetadata ? addMetadata() : editMetadata()})}
                                aria-label={m.event_group_metadata_form_label()}>
                                <div class="row">
                                    <div class="col">
                                        <div class="mb-3">
                                            <label class="form-label" for="metadataPropInput">{m.event_group_metadata_property_label()}</label>
                                            <input class="form-control" 
                                                type="text" 
                                                id="metadataPropInput"
                                                bind:value={metadataProp}
                                                aria-required="true">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="mb-3">
                                            <label class="form-label" for="metadataValueInput">{m.event_group_metadata_value_label()}</label>
                                            <input class="form-control" 
                                                type="text" 
                                                id="metadataValueInput"
                                                bind:value={metadataValue}
                                                aria-required="true">
                                        </div>
                                    </div>
                                </div>
                                <div class="d-xxl-flex justify-content-xxl-end mb-3">
                                    <div class="btn-group" role="group" aria-label={m.event_group_metadata_actions_label()}>
                                        {#if selectedMetadata}
                                        <button class="btn btn-info text-white" 
                                            type="button" 
                                            id="editMetadataBtn"
                                            aria-label={m.event_group_metadata_save_changes_label()}
                                            onclick={() => editMetadata()}>{m.event_group_metadata_edit_button()}</button>
                                        {:else}
                                        <button class="btn btn-primary" 
                                            type="button"
                                            id="saveMetadataBtn"
                                            aria-label={m.event_group_metadata_save_new_label()}
                                            onclick={() => addMetadata()}>{m.event_group_metadata_save_button()}</button>
                                        {/if}
                                        <button class="btn btn-light" 
                                            type="button"
                                            id="resetFormBtn"
                                            aria-label={m.event_group_metadata_reset_label()}
                                            onclick={() => reset()}>{m.event_group_metadata_reset_button()}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{m.event_group_metadata_table_property()}</th>
                                            <th>{m.event_group_metadata_table_value()}</th>
                                            <th>{m.event_group_metadata_table_action()}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each eventGroupState[projectState.selected].metadata as meta, index (meta.id)}
                                        <tr>
                                            <td>{meta.prop}</td>
                                            <td>{meta.value}</td>
                                            <td>
                                                <div class="btn-group btn-group-sm" role="group">
                                                    <button aria-label={m.event_group_metadata_select_label()} class="btn btn-primary" onclick={() => selectMetadata(meta)} type="button"><i class="bi bi-pencil-square"></i></button>
                                                    <button aria-label={m.event_group_metadata_remove_label()} class="btn btn-danger text-white" onclick={() => removeMetadata(meta.id)} type="button"><i class="bi bi-trash"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                        {/each}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
